module.exports = __webpack_public_path__ + "img/Bhutan.1d530204.png";